import {createSlice} from "@reduxjs/toolkit";
import {cloneDeep, defaultsDeep} from "lodash";

const initialState = {
  carousel: {
    loading: false,
    error: '',
    data: {web: [], mobile: []},
    init: false
  },
  remoteConfigs: {
    loading: false,
    error: '',
    data: {notice: {}, roadblock: {}},
    init: false
  },
  weeklyBrands: {
    loading: false,
    error: '',
    data: [],
    init: false
  },
  promotionalEvents: {
    loading: false,
    error: '',
    data: [],
    init: false
  },
  campaigns: {
    loading: false,
    error: '',
    data: [],
    init: false
  },
  bundleTimers: {
    loading: false,
    error: '',
    data: [],
    init: false
  },
  allBrands: {
    loading: false,
    error: '',
    data: [],
    init: false,
    hasNext: true,
    page: 0,
    totalResults: 0
  },
  featuredBrands: {
    loading: false,
    error: '',
    data: [],
    init: false,
    hasNext: true,
    page: 0,
    totalResults: 0
  },
  // dynamic_banner:{
  //   loading:false,
  //   error: '',
  //   data:[], 
  //   init: false,
  //   ext:'' 
  // }, 
  editing: {
    loading: false,
    visible: false
  }
};

const dynamicElementsSlice = createSlice({
  name: 'dynamicElements',
  initialState: initialState,
  reducers: {

    setLoading: (state, action) => {
      state[action.payload.element].error = '';
      state[action.payload.element].loading = action.payload.loading;
    },
    setResult: (state, action) => {
      state[action.payload.element].error = action.payload.error;
      state[action.payload.element].loading = false;
      if (!action.payload.error) {

        state[action.payload.element].init = true;
        if(action.payload.toggle!==undefined){
          state[action.payload.element].toggle = action.payload.toggle;
        }
        if (action.payload.hasNext !== undefined) {
          state[action.payload.element].hasNext = action.payload.hasNext;
          state[action.payload.element].totalResults = action.payload.totalResults;
          state[action.payload.element].page = action.payload.page;
          state[action.payload.element].data = [...state[action.payload.element].data, ...action.payload.data];
        } else {
          state[action.payload.element].data = action.payload.data;
        }
      }

    },
    reset: (state, action) => {
      state[action.payload.element] = initialState[action.payload.element];
    },
    setVisibility: (state, action) => {
      state[action.payload.element ?? 'editing'].visible = action.payload.visible;
      state[action.payload.element ?? 'editing'].type = action.payload.visible ? (action.payload.type ?? "edit") : undefined;
    },
    resetAll: (state, action) => initialState,

    //carousel
    loadCarousel() {
    },
    loadWeeklyBrands() {
    },
    loadAllBrands() {
    },
    loadRemoteConfigs() {
    },
    loadCampaigns() {
    },
    loadPromotionalEvents() {
    },
    loadBannerPages() {
    },
    loadBundleTimers() {
    },
    tryUpdateBundleTimerItem() {
    }

  }
});


export const {
  setLoading,
  setResult,
  reset,
  loadCarousel,
  loadWeeklyBrands,
  loadAllBrands,
  loadRemoteConfigs,
  loadCampaigns,
  loadPromotionalEvents,
  resetAll,
  loadBundleTimers,
  tryUpdateBundleTimerItem,
  setVisibility


} = dynamicElementsSlice.actions;

export default dynamicElementsSlice.reducer;